<template>
    <!-- 日期 -->
    <div class="search-form-container sailDate-search-form" :class="{'f-dn': !isShow}" data-key="SailDate">
        <div class="sailDate-search-form-container" :data-type="cruiseType">
            <div class="switch-arrow left-arrow" data-switch="left" 
            v-if="shouldShowPageTwo && currentIndex == 1"
            @click="changeIndex('left')">
                <img src="https://resource.rcclchina.com.cn/partner/left_arrow.png" />
            </div>
            <div v-else class="f-dn"></div>
            <div class="switch-arrow right-arrow" data-switch="right" 
            v-if="shouldShowPageTwo && currentIndex == 0"
            @click="changeIndex('right')"
            >
                <img src="https://resource.rcclchina.com.cn/partner/right_arrow.png" />
            </div>
            <div v-else class="f-dn"></div>
            <div class="sailDate-search-form-wrapper">
                <div class="sailDate-search-form-slider" data-slider-index="0" :class="{ active: currentIndex == 0}" >
                    <div class="sailDate-search-form-left sailDate-search-form-content">
                        <div class="sailDate-search-form-title">
                            {{getCalendarYear(0)}}年
                        </div>
                        <div class="sailDate-search-form-month-container">
                            <div class="sailDate-search-form-month-line" v-for="i in 3" :key="i">
                                    <div v-for="line in 4" :key="line" class="sailDate-search-form-month search-form-list-item"
                                    @click="onSailDateClick(getCalendarYear(0) + '-' + getCalendarMonth(i, line, true))" 
                                    :class="{ 
                                        active: isSelected(getCalendarYear(0) + '-' + getCalendarMonth(i, line, true)),
                                        disable: isDisable(getCalendarYear(0) + '-' + getCalendarMonth(i, line, true))
                                    }"
                                    data-key="SailDate">
                                    {{getCalendarMonth(i, line, false)}}月
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sailDate-search-form-separator "></div>
                    <div class="sailDate-search-form-right sailDate-search-form-content">
                        <div class="sailDate-search-form-title">
                            {{getCalendarYear(1)}}年
                        </div>
                        <div class="sailDate-search-form-month-container">
                            <div class="sailDate-search-form-month-line" v-for="i in 3" :key="i">
                                    <div v-for="line in 4" :key="line" class="sailDate-search-form-month search-form-list-item"
                                    @click="onSailDateClick(getCalendarYear(1) + '-' + getCalendarMonth(i, line, true))" 
                                    :class="{ 
                                        active: isSelected(getCalendarYear(1) + '-' + getCalendarMonth(i, line, true)),
                                        disable: isDisable(getCalendarYear(1) + '-' + getCalendarMonth(i, line, true))
                                    }"
                                    data-key="SailDate">
                                    {{getCalendarMonth(i, line, false)}}月
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="shouldShowPageTwo" class="sailDate-search-form-slider" :class="{ active: currentIndex == 1}" data-slider-index="1">
                    <div class="sailDate-search-form-left sailDate-search-form-content">
                        <div class="sailDate-search-form-title">
                            {{getCalendarYear(2)}}年
                        </div>
                        <div class="sailDate-search-form-month-container">
                            <div class="sailDate-search-form-month-line" v-for="i in 3" :key="i">
                                    <div v-for="line in 4" :key="line" class="sailDate-search-form-month search-form-list-item"
                                    @click="onSailDateClick(getCalendarYear(2) + '-' + getCalendarMonth(i, line, true))" 
                                    :class="{ 
                                        active: isSelected(getCalendarYear(2) + '-' + getCalendarMonth(i, line, true)),
                                        disable: isDisable(getCalendarYear(2) + '-' + getCalendarMonth(i, line, true))
                                        }"
                                    data-key="SailDate">
                                    {{getCalendarMonth(i, line, false)}}月
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="search-form-clear" @click="onClearClick()">
            <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-clear.png" />
            <span>清空全部</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SailDateForm',
    components: {
        
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        isShow: {
            type: Boolean,
            default: function() {
                return false
            }
        }
    },
    data () {
        return {
            today: new Date(),
            currentIndex: 0,
            selectedSailDates: []
        }
    },
    methods: {
        getCalendarYear (addYear) {
            return this.today.getFullYear() + addYear
        },
        getCalendarMonth (i, lineIndex, needPrefix) {
            let monthStr = ""
            let month = 4 * (i - 1) + lineIndex
            if (month > 12) {
                return monthStr
            }
            if (!needPrefix) {
                return month + ""
            }
            monthStr = month + ""
            if (month < 10) {
                monthStr = "0" + month
            }
            return monthStr
        },
        changeIndex(direction) {
            if (direction == 'left' && this.currentIndex > 0) {
                this.currentIndex--
            } else if (direction == 'right' && this.currentIndex < 1) {
                this.currentIndex++
            }
        },
        onSailDateClick (sailDate) {
            if (this.isDisable(sailDate)) {
                return
            }
            const cruiseType = this.cruiseType
            const data = {
                cruiseType,
                key: 'sailDates',
                values: [{
                    code: sailDate,
                    name: sailDate
                }]
            }
            if (!this.selectedSailDates.includes(sailDate)) {
                this.selectedSailDates.push(sailDate)
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            } else {
                this.selectedSailDates = this.selectedSailDates.filter(item=>!(item == sailDate))
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            }
        },
        isSelected (sailDate) {
            return this.selectedSailDates.includes(sailDate)
        },
        onClearClick () {
            let data = {
                cruiseType: this.cruiseType,
                key: 'sailDates',
                values: []
            }
            this.selectedSailDates.forEach((date) => {
                data.values.push({
                    code: date
                })
            })
            this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            this.selectedSailDates = []
        },
        isDisable (code) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].sailDates
            return !availableItems.includes(code)
        }
    },
    computed: {
        shouldShowPageTwo () {
            return true
            // return this.cruiseType == "row"
        }
    }
}
</script>

<style>
.cruise_search .search_form .sailDate-search-form .sailDate-search-form-month-line .sailDate-search-form-month {
    margin: 0px 2px;
}
</style>
